import TargetingService, { TARGETING } from "Services/targeting";
import Analytics from "Services/analytics";
import UserService from "Services/user";
import { getCookie, setCookie } from "Services/cookie";

const IS_FULL_STORY_INITED = "is_fs_inited";

const FREQUENCY = 1;

function bet() {
  return Math.floor(Math.random() * FREQUENCY) % FREQUENCY === 0;
}

class FullStory {
  constructor() {
    this.isInited = Boolean(getCookie(IS_FULL_STORY_INITED));
    if (this.isInited) {
      this.trackFullStory();
    }
  }

  randomInit() {
    if (this.isInited || !bet()) {
      return;
    }

    this.trackFullStory();
  }

  async targetingInit() {
    if (this.isInited) {
      return;
    }

    const result = await TargetingService.check(TARGETING.FULL_STORY_ON);
    if (result.is_suitable) {
      this.trackFullStory();
    }
  }

  async trackFullStory() {
    if (UserService.isReadOnly()) {
      return;
    }

    await Analytics.trackFullStory();
    await setCookie(IS_FULL_STORY_INITED, true, "/");
    this.isInited = true;
  }
}

const fullStoryInstance = new FullStory();

export default fullStoryInstance;